export const URL_API_PRODUCCION = 'https://vida.vicenteserran.com';
export const URL_API_DESARROLLO = 'http://localhost:3000';

export function esNativo(capacitor) {
  const cap = capacitor !== undefined
    ? capacitor
    : (typeof window !== 'undefined' ? window.Capacitor : undefined);
  return Boolean(cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform());
}

export function esHostDesarrollo(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '10.0.2.2';
}

export function getBaseURL(opciones = {}) {
  const hostname = opciones.hostname !== undefined
    ? opciones.hostname
    : (typeof window !== 'undefined' && window.location ? window.location.hostname : '');
  const capacitor = opciones.capacitor !== undefined
    ? opciones.capacitor
    : (typeof window !== 'undefined' ? window.Capacitor : undefined);

  if (esNativo(capacitor)) {
    return URL_API_PRODUCCION;
  }
  if (esHostDesarrollo(hostname)) {
    return URL_API_DESARROLLO;
  }
  return '';
}

export function timeoutAxios(opciones = {}) {
  return esNativo(opciones.capacitor) ? 20000 : 10000;
}
